import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from '@core/appconfig.service';
import {
  StatefulService
} from '@core/services/stateful-service-management/stateful-service-interface/stateful-service-interface';
import { ApiResponse } from '@models/api-response';
import { IProductLine } from '@models/product-line';
import { BehaviorSubject, map } from 'rxjs';

/** Contains State and API calls */
@Injectable({
  providedIn: 'root'
})
export class EceProductService implements StatefulService {
  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
  ) {}

  productLine$: BehaviorSubject<IProductLine> = new BehaviorSubject<IProductLine>(null);
  themeId: string = null;

  set productLine(productLine: IProductLine) {
    if (productLine !== this.productLine$.value) {
      this.productLine$.next(productLine);
    }
  }

  getMaterial(queryString: string) {
    const url: string = `${this.getMaterialUrl()}?${queryString}`;

    return this.http.get<ApiResponse<any>>(url)
      .pipe(
        map(res => new ApiResponse<any>(true, { response: true, messages: [...res.response] })),
      );
  }

  private getMaterialUrl(): string {
    return `${this.appConfig.apiUrl}/digital-resources/material`;
  }

  /** Resets the stateful properties of this service. */
  reset(): void {
    this.productLine$.next(null);
    this.themeId = null;
  }
}
